module.exports = __webpack_public_path__ + "cd455783/img/rename-icon.de4e673d.svg";